import React, { Component } from 'react'
import { connect } from 'react-redux'
import { closeDialog } from './actions/dialogActions'
import { DialogView } from './DialogView'

class DialogsContainer extends Component {
  render () {
    const { dialogs, closeDialog } = this.props
    const toRender = []
    dialogs.forEach(dialog => {
      toRender.push(<DialogView state={{
        ...dialog.state,
        closeSelf: (_, reason) => {
          if (reason !== 'backdropClick') {
            closeDialog(dialog.id)
          }
        }
        // closeDialog(dialog.id)
      }} key={dialog} />)
    })
    return <div>{toRender}</div>
  }
}

const mapStateToProps = (state) => {
  return {
    dialogs: state.dialogs.dialogs
  }
}

const mapActionsToProps = {
  closeDialog
}

export default connect(mapStateToProps, mapActionsToProps)(DialogsContainer)
